document.querySelectorAll('[data-randomize-same-collection]').forEach((section) => {
  const list = section.querySelector('.resource-list--grid');
  const limit = Number.parseInt(section.dataset.displayLimit || '4', 10);
  const cards = Array.from(list?.querySelectorAll(':scope > .resource-list__item') || []);

  for (let index = cards.length - 1; index > 0; index -= 1) {
    const randomIndex = Math.floor(Math.random() * (index + 1));
    [cards[index], cards[randomIndex]] = [cards[randomIndex], cards[index]];
  }

  cards.forEach((card, index) => {
    if (index < limit) {
      list.append(card);
    } else {
      card.remove();
    }
  });
});

document.querySelectorAll('[data-product-upsell]').forEach((section) => {
  const limit = Number.parseInt(section.dataset.displayLimit || '3', 10);
  const list = section.querySelector('[data-upsell-list]');
  const cards = Array.from(list?.querySelectorAll('.lm-upsell-card') || []);

  for (let index = cards.length - 1; index > 0; index -= 1) {
    const randomIndex = Math.floor(Math.random() * (index + 1));
    [cards[index], cards[randomIndex]] = [cards[randomIndex], cards[index]];
  }

  cards.forEach((card, index) => {
    if (index < limit) {
      list.append(card);
    } else {
      card.remove();
    }
  });
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('.lm-upsell-card__form');
  if (!form) return;

  event.preventDefault();

  const button = form.querySelector('button[type="submit"]');
  const originalLabel = button.textContent.trim();
  const formData = new FormData(form);
  const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
    .map((component) => component.dataset.sectionId)
    .filter(Boolean);

  if (sectionIds.length > 0) formData.set('sections', sectionIds.join(','));

  button.disabled = true;
  button.textContent = `${button.dataset.addLabel}…`;

  try {
    const rootUrl = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${rootUrl}cart/add.js`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    });
    const result = await response.json();

    if (!response.ok || result.status) throw new Error(result.description || result.message);

    const cartResponse = await fetch(`${rootUrl}cart.js`);
    const cart = await cartResponse.json();

    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: form.id,
          data: {
            source: 'product-upsell',
            itemCount: cart.item_count,
            variantId: String(formData.get('id')),
            sections: result.sections,
          },
        },
      }),
    );

    button.textContent = button.dataset.addedLabel;
    setTimeout(() => {
      button.textContent = originalLabel;
      button.disabled = false;
    }, 1400);
  } catch (error) {
    button.textContent = error.message || originalLabel;
    setTimeout(() => {
      button.textContent = originalLabel;
      button.disabled = false;
    }, 2500);
  }
});
